module.exports = __webpack_public_path__ + "569a78e2a5af112d9efd252f5922e29e.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/will-klein.jpg
// module id = 527
// module chunks = 0